// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const DynamicApplicationScanRunStatusSchema = z.enum(['QUEUED','RUNNING','COMPLETED','FAILED','STOPPED'] as const);

export type DynamicApplicationScanRunStatusType = `${z.infer<typeof DynamicApplicationScanRunStatusSchema>}`

export default DynamicApplicationScanRunStatusSchema;
